import { makeStyles } from '@material-ui/core/styles'
import { RootState } from 'app/store'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import { SessionState, sessionStoreKey } from 'core/session/sessionReducers'
import Theme from 'core/themes/model'
import { prop } from 'ramda'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    height: 'calc(100vh - 80%)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    alignItems: 'center',
    justifyContent: 'center',
  },
  infoText: {
    width: '400px',
    textAlign: 'center',
  },
  icon: {
    color: theme.palette.grey[100],
  },
}))

export default function GetStartedWithBlueprint({ onClick }: { onClick: () => void }) {
  const classes = useStyles()
  const session = useSelector<RootState, SessionState>(prop(sessionStoreKey))
  const username = session?.userDetails?.displayName || session?.userDetails?.username

  return (
    <div className={classes.root}>
      <div className={classes.cardBody}>
        <Text variant="subtitle1">Welcome, {username}!</Text>
        <Text variant="h2">Create your Cluster Blueprint</Text>
        <div className={classes.infoText}>
          <Text component="p" variant="body1">
            Cluster Blueprint enables you to configure your private cloud in a standardized way.
          </Text>
        </div>
        <Button onClick={onClick} data-testid="create-cluster-blueprint-button">
          <FontAwesomeIcon className={classes.icon} solid>
            plus
          </FontAwesomeIcon>{' '}
          Create Cluster Blueprint
        </Button>
      </div>
    </div>
  )
}
